import {GET, POST} from "../util";

const inspectionUrl = "api/investments-receivables-inspection";
const operationUrl = "api/investments-receivables-operation";

const url = {
    inspection: {
        accounts: `${inspectionUrl}/accounts`,
        list: `${inspectionUrl}/list/:accountId`,
        downloadAllDocuments: `${inspectionUrl}/download-all-documents`,
        downloadAllCollectionDocuments: `${inspectionUrl}/download-all-collection-documents/{receivableId}`,
        exportCsv: `${inspectionUrl}/export-csv/:accountId/:fromDate/:toDate`,
        reportFields: `${inspectionUrl}/export-csv/buyer-fields`,
        reminderLogHistory: `${inspectionUrl}/reminder-log-history/:receivableId/list`,
    },

    operation: {
        resell: `${operationUrl}/resell`,
        requestIpu: `${operationUrl}/request-ipu/:receivableId`,
    }
};
const allInvestmentsReceivablesApi = {
    inspection: {
        getAccounts: () => {
            return GET(url.inspection.accounts);
        },
        list: (accountId, params = {}) => {
            return POST(url.inspection.list.replace(":accountId", accountId), params);
        },
        downloadAllDocuments: (params = {}) => {
            return POST(url.inspection.downloadAllDocuments, params);
        },
        downloadAllCollectionDocuments: (receivableId) => {
            return GET(url.inspection.downloadAllCollectionDocuments.replace('{receivableId}', receivableId));
        },
        exportCsvUrl: (params = {}) => {
            return POST(url.inspection.exportCsv
                .replace(":accountId", params.accountId)
                .replace(":fromDate", params.fromDate)
                .replace(":toDate", params.toDate),
                params.fieldList,
                "application/json",
                "Array",
                true);
        },
        reportFields: () => {
            return GET(url.inspection.reportFields);
        },
        reminderLogHistory: (receivableId) => {
            return GET(url.inspection.reminderLogHistory.replace(":receivableId", receivableId));
        },
    },
    operation: {
        resell: (params) => {
            return POST(url.operation.resell, params);
        },
        requestIpu: (receivableId) => {
            return POST(url.operation.requestIpu.replace(":receivableId", receivableId));
        },
    }
};
export {
    allInvestmentsReceivablesApi
};